export default __webpack_public_path__ + "static/media/1586.708c96ca.png";